import { IDevice } from './events.interfaces';

export interface INotificationSubscription extends PushSubscriptionJSON {
  user_id: string | string[];
  expirationTime: number;
  device?: IDevice;
}
export interface IPushTemplate {
  _id?: string;
  subject: string;
  params?: Object;
  text: string;
  imageUrl: string;
  action?: SITE_NOTIFICATION_ACTIONS;
  actionUrl?: string;
  prompt: boolean;
  timestamp: number;
}
export interface ISiteNotification extends IPushTemplate {
  user_id: string;
  readedAt?: number;
  state: SITE_NOTIFICATION_STATE;
  type: SITE_NOTIFICATION_TYPE;
  origin: SITE_NOTIFICATION_ORIGIN;
}

export enum SITE_NOTIFICATION_STATE {
  PENDING = 'PENDING',
  POOL = 'POOL',
  UNREADED = 'UNREADED',
  READED = 'READED',
}
export enum SITE_NOTIFICATION_TYPE {
  PLATFORM = 'PLATFORM',
  PERSONAL = 'PERSONAL',
}
export enum SITE_NOTIFICATION_ORIGIN {
  STAFF = 'STAFF',
  FASTTRACK = 'FASTTRACK',
}
export enum SITE_NOTIFICATION_ACTIONS {
  PLAY = 'PLAY',
  JOIN = 'JOIN',
  SEE = 'SEE',
  READ = 'READ',
}
export enum TEMPLATE_SELECTION {
  SELECTED_USERS = 'SELECTED_USERS',
  ALL_ACTIVE_USERS = 'ALL_ACTIVE_USERS',
  REGISTERED_NOT_DEPOSITS = 'REGISTERED_NOT_DEPOSITS',
  REGISTERED_ONE_DEPOSIT = 'REGISTERED_ONE_DEPOSIT',
}
